import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpandAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";
import { PullerContainer, ConsoleDrawer, ConsoleActions } from "./ConsoleUi.style";
import ConsoleTabs from "./ConsoleTabs";
import { maximizeConsoleState, openConsoleState, websocketState } from "./ConsoleUi.state";
import { memo, useEffect } from "react";
import { useUserQuery } from "../../monitor/User.state";

const ConsoleUi = () => {
    const { t } = useTranslation();
    const { super_admin } = useUserQuery();
    const [open, setOpen] = useRecoilState(openConsoleState);
    const [max, setMax] = useRecoilState(maximizeConsoleState);
    const [wsMessage, setWsMessage] = useRecoilState(websocketState);
    useEffect(() => {
        const messagesPerSession = 100
        function clearLogs() {
            setWsMessage([])
        }

        // clear logs when user is closing the browser window
        window.addEventListener('beforeunload', clearLogs);

        // also clear logs when it reaches maximum number per session
        if (wsMessage?.length > messagesPerSession) {
            clearLogs()
        }

        return () => {
            window.removeEventListener('beforeunload', clearLogs);
        }
    }, [setWsMessage, wsMessage])

    return super_admin
        ? (
            <>
                <ConsoleDrawer
                    anchor="bottom"
                    open={open}
                    onClose={() => setOpen(false)}
                    ModalProps={{
                        keepMounted: true,
                    }}
                >
                    <PullerContainer>
                        <ConsoleActions>
                            <FontAwesomeIcon title={t(`Close console`)} icon={faTimes} onClick={() => setOpen(false)} />
                            <FontAwesomeIcon title={t(max ? `Minimize console` : `Maximize console`)} icon={faExpandAlt} onClick={() => setMax(!max)} />
                        </ConsoleActions>
                    </PullerContainer>
                    <ConsoleTabs />
                </ConsoleDrawer>
            </>
        )
        : null
}

export default memo(ConsoleUi);